import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import DueDateField from './DueDateField'
import RequestedFileCell from './RequestedFileCell'
import Chip from '../../../../../../../components/Chip'
import Button from '../../../../../../../components/Button'

import { CHIP_COLORS } from '../../../../../../../constants/other'
import { tableColumnsSize, uploadRemoveStyle } from '../../const/columns'

export const useRequestedFilesColumns = ({ openUploadFileForm, periodStartColumn }) => {
  const { t } = useTranslation()

  const requestedFilesColumns = useMemo(
    () => [
      {
        header: 'Requested file',
        Cell: ({ requested_file, uploaded_files }) => {
          const hasMultipleFiles = uploaded_files?.length > 1

          return <RequestedFileCell requestedFile={requested_file} hasMultipleFiles={hasMultipleFiles} />
        }
      },
      periodStartColumn,
      {
        header: 'Due date',
        Cell: ({ requested_file, uploaded_files: uploadedFiles }) =>
          !uploadedFiles?.length ? <DueDateField deadline={requested_file.deadline_date} /> : '',
        style: { maxWidth: tableColumnsSize.dueDate }
      },
      {
        header: 'Status',
        Cell: ({ requested_file, uploaded_files }) => {
          const hasMultipleFiles = uploaded_files?.length > 1
          // check if file is floated(not linked to requested file, custom date or etc..)
          const isFloatedFile = !!requested_file.note_code
          const isFileRequired = requested_file?.required_file
          if (hasMultipleFiles || isFloatedFile || !isFileRequired) {
            return null
          }

          return <Chip text={t('Required')} color={CHIP_COLORS.grey} />
        },
        style: { width: tableColumnsSize.status, minWidth: tableColumnsSize.status }
      },
      {
        Cell: ({ requested_file, uploaded_files }) => {
          // check if file is floated(not linked to requested file, custom date or etc..)
          const isFloatedFile = !!requested_file.note_code
          const hasMultipleFiles = uploaded_files?.length > 1
          if (isFloatedFile || hasMultipleFiles) {
            return null
          }

          return (
            <Button
              isSmall={true}
              solid
              onClick={openUploadFileForm({
                requestedFileId: requested_file.id,
                mediaId: requested_file.booked_media_id,
                customDate: requested_file.custom_date && requested_file.date_start
              })}
            >
              {t('Upload')}
            </Button>
          )
        },
        style: uploadRemoveStyle
      },
      {
        // placeholder for the dropdown
        Cell: () => null,
        style: { maxWidth: tableColumnsSize.actions }
      }
    ],
    [openUploadFileForm, periodStartColumn, t]
  )

  return requestedFilesColumns
}
